import { FC } from 'react';
import { useFragment } from 'react-relay';
import graphql from 'babel-plugin-relay/macro';

import { CountrySelect_data$key } from '__generated__/CountrySelect_data.graphql';
import Autocomplete, { AutocompleteProps } from 'components/Autocomplete';

type Props = Omit<AutocompleteProps, 'options'> & {
  data: CountrySelect_data$key;
};

const CountrySelect: FC<Props> = props => {
  const { countries } = useFragment(
    graphql`
      fragment CountrySelect_data on Query {
        countries(first: 2147483647) {
          edges {
            node {
              id
              name
            }
          }
        }
      }
    `,
    props.data
  );

  return (
    <Autocomplete
      options={countries?.edges.map(({ node }) => node) ?? []}
      {...props}
    />
  );
};

export default CountrySelect;
